// @ts-nocheck
import {useListView} from './core/ListViewProvider'
import {UsersListHeader} from './components/header/UsersListHeader'
import {UsersTable} from './table/UsersTable'
import {KTCard} from '../../../../_metronic/helpers'
import {useEffect, useState, useCallback} from 'react'
import {useParams} from 'react-router-dom'

const UsersList = () => {
  const [userSearch, setUserSearch] = useState('')
  const [genderFilter, setGenderFilter] = useState('')
  const [typeFilter, setTypeFilter] = useState('')
  const [locationFilter, setLocationFilter] = useState('')
  const [applyFilter, setApplyFilter] = useState<boolean>(false)
  const [sDate, setSDate] = useState<any>('')
  const [eDate, setEDate] = useState<any>('')
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState<boolean>(false)
  const [usersData, setUsersData] = useState<any[]>([])

  const handleDataChange = useCallback((data: any[]) => {
    console.log('🔄 Users data changed in parent:', data)
    setUsersData(data)
  }, [])

  useEffect(() => {}, [])

  return (
    <>
      <KTCard>
        {/* Search | Filter | Export Button Begins */}
        <UsersListHeader
          genderFilter={genderFilter}
          setGenderFilter={setGenderFilter}
          userSearch={userSearch}
          setUserSearch={setUserSearch}
          sDate={sDate}
          setSDate={setSDate}
          eDate={eDate}
          setEDate={setEDate}
          page={page}
          setPage={setPage}
          typeFilter={typeFilter}
          setTypeFilter={setTypeFilter}
          locationFilter={locationFilter}
          setLocationFilter={setLocationFilter}
          applyFilter={applyFilter}
          setApplyFilter={setApplyFilter}
          loading={loading}
          setLoading={setLoading}
          usersData={usersData}
        />
        {/* Search | Filter | Export Button Ends */}
        <UsersTable
          genderFilter={genderFilter}
          setGenderFilter={setGenderFilter}
          userSearch={userSearch}
          setUserSearch={setUserSearch}
          sDate={sDate}
          setSDate={setSDate}
          eDate={eDate}
          setEDate={setEDate}
          page={page}
          setPage={setPage}
          typeFilter={typeFilter}
          setTypeFilter={setTypeFilter}
          locationFilter={locationFilter}
          setLocationFilter={setLocationFilter}
          applyFilter={applyFilter}
          setApplyFilter={setApplyFilter}
          loading={loading}
          setLoading={setLoading}
          onDataChange={handleDataChange}
        />
      </KTCard>
    </>
  )
}

const UsersListWrapper = () => <UsersList />

export {UsersListWrapper}
